const iconMapping = {
}

export default iconMapping;